import { CLEAR_FETCH_ERROR, SET_FETCH_ERROR } from '../actions/FetchActions';

function fetchError(state = null, action) {
  switch (action.type) {
    case SET_FETCH_ERROR:
      return {
        message: action.message,
        variant: action.variant,
        link: action.link,
        key: action.key,
      };
    case CLEAR_FETCH_ERROR:
      // Navigation clears unconditionally; a retry clears only its own banner.
      if (action.key && state && state.key !== action.key) return state;
      return null;
    default:
      return state;
  }
}

export default { fetchError };
